import { render } from "./EmployeeForm.vue?vue&type=template&id=74b24893"
import script from "./EmployeeForm.vue?vue&type=script&lang=ts"
export * from "./EmployeeForm.vue?vue&type=script&lang=ts"
script.render = render

export default script